import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.png";

export const obsidianSecurity = defineConnector({
  identifier: "obsidianSecurity",
  name: "Obsidian Security",
  tagLine: "SaaS security posture and threat detection",
  keywords: "sspm saas posture compliance identity threats obsec",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) => exactUrlToRegex(baseUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  aiContext:
    "Third-party API reference: https://docs.brinqa.com/docs/connectors/obsidian-security/. Official documentation is available through the book icon in the Obsidian portal.",
  steps: [
    {
      title: "Create an API token in Obsidian Security",
      items: [
        {
          kind: "markdown",
          content: `1. Sign in to Obsidian Security as an administrator.
2. Open **Settings → API access tokens** and select **Create token**.
3. Enter a token name and set **Expiry date** to **Forever**.
4. Under **Token access → Role**, select **API**. Under **Service access**, enable **Full data access to all services and tenants**.
5. Select **Submit** and copy the token.`,
        },
      ],
    },
    {
      title: "Enter your Obsidian Security details",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "https://api.obsec.io",
          target: { kind: "configuration", field: "baseUrl" },
          options: [
            { value: "https://api.obsec.eu", label: "Europe (*.obsec.eu)" },
            {
              value: "https://api.sy.obsec.io",
              label: "Australia (*.sy.obsec.io)",
            },
            { value: "https://api.obsec.io", label: "America (*.obsec.io)" },
          ],
          helperText:
            "Select the region matching your Obsidian Security URL. For *.sy.obsec.io, select Australia.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url: `${baseUrl.trim().replace(/\/+$/, "")}/v1/connection-management/tenants`,
      expectedStatus: 200,
    }),
  },
  publicEnvVars: ({ baseUrl }) => ({
    OBSIDIAN_SECURITY_URL: baseUrl ? baseUrl.trim().replace(/\/+$/, "") : "",
  }),
});
